module.exports = __webpack_public_path__ + "static/img/cg.c0adcefa.svg";